import { FeedbackStatus } from "../../api/feedback";

const STYLES: Record<FeedbackStatus, string> = {
  pending: "bg-slate-800 text-slate-300",
  triaged: "bg-sky-500/15 text-sky-300",
  planned: "bg-amber-500/15 text-amber-300",
  in_progress: "bg-amber-500/25 text-amber-200",
  deployed: "bg-emerald-500/15 text-emerald-300",
  wont_do: "bg-slate-700/40 text-slate-500 italic",
  duplicate: "bg-slate-700/40 text-slate-500 italic",
};

const LABEL: Record<FeedbackStatus, string> = {
  pending: "pending",
  triaged: "triaged",
  planned: "planned",
  in_progress: "in progress",
  deployed: "deployed",
  wont_do: "won't do",
  duplicate: "duplicate",
};

export default function StatusBadge({ status }: { status: FeedbackStatus }) {
  return (
    <span
      className={`rounded-full px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide ${STYLES[status]}`}
    >
      {LABEL[status]}
    </span>
  );
}

export const STATUS_LABEL = LABEL;
